import { render, staticRenderFns } from "./Transactions.html?vue&type=template&id=5ad20e48&scoped=true&"
import script from "./Transactions.ts?vue&type=script&lang=ts&"
export * from "./Transactions.ts?vue&type=script&lang=ts&"
import style0 from "./Other.css?vue&type=style&index=0&id=5ad20e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad20e48",
  null
  
)

export default component.exports